import { useNavigate } from "react-router";
import { SocialMediaLink } from "../../molecules/SocialMediaLink";
import { ButtonToTopOfPage } from "../../molecules/ButtonToTopOfPage";

export const Footer = () => {
  const navigate = useNavigate();
  return (
    <div className="bg-black text-white">
      <ButtonToTopOfPage className="mx-auto mb-5 w-5" />
      <footer className="mx-auto w-full max-w-7xl border-t border-gray-900 p-4">
        <div className="flex flex-col items-center pt-5">
          <div className="flex flex-col opacity-80">
            <span className="text-xl sm:ml-10">
              If you have a General Or Project enquiry,
            </span>
            <span className="mt-2 text-xl">please drop me an email.</span>
          </div>
          <button
            onClick={() => navigate("/contacts")}
            className="mt-8 rounded-2xl border-2 border-cream-700 p-5 hover:opacity-50"
          >
            <span className="my-5 text-3xl">SEND AN EMAIL</span>
          </button>
        </div>
        <div className="mt-4 flex">
          <SocialMediaLink
            link="https://www.instagram.com/joybigman/"
            icon="instagram"
            className="mr-4"
          />
          <SocialMediaLink
            link="https://www.facebook.com/profile.php?id=61566530387861"
            icon="facebook"
            className="mr-4"
          />
          <SocialMediaLink
            link="https://www.tiktok.com/@dziugasjoy"
            icon="tiktok"
          />
        </div>
        <div className="mt-4 flex flex-col items-center">
          <span className="text-sm">Džiugas Petkūnas 2024</span>
        </div>
        <div className="mt-10 flex flex-col items-center opacity-80">
          <span className="ml-auto text-sm">Developer: Paulius Padriezas</span>
          <span className="ml-auto text-sm">Designer: Osvaldas Galeckas</span>
        </div>
      </footer>
    </div>
  );
};
